/**
 * ATTENTION: This file is auto generated by using "prepareTemplates".
 * Do not change the content!
 *
 */

/**
 * Library Index skip-content to autogenerate all the components and extensions
 * Used by "prepareSkipContents"
 */

import SkipContent from './skip-content/SkipContent'
export * from './skip-content/SkipContent'
export default SkipContent
